export const GET_COUNTRIES = 'GET_COUNTRIES'
export const GET_SHIPPING_ADDRESS = 'GET_SHIPPING_ADDRESS'
